import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { SignUpContext } from "../../../../../contexts";
import "../../../../components-styles.scss";
import EstablishementAdressFormWrapper from "../../../../Common/EstablishmentAdressFormWrapper";
import CustomButton from "../../../../UIElements/CustomButton";

type EstablishmentAdressFormProps = {
    goto?: (step: number) => void;
    nextStep?: number;
};

export default function EstablishmentAddressForm({
    goto,
    nextStep,
}: EstablishmentAdressFormProps) {
    const { updateSignupForm, ...signupForm } = useContext(SignUpContext);

    const defaultValues = {
        contactAddress: {
            postalCode:
                signupForm.signupUser.establishment.contactAddress.postalCode ??
                "",
            city: signupForm.signupUser.establishment.contactAddress.city,
            street: signupForm.signupUser.establishment.contactAddress.street,
            additionalDetails:
                signupForm.signupUser.establishment.contactAddress
                    .additionalDetails,
        },
        billingAddress: {
            postalCode:
                signupForm.signupUser.establishment.billingAddress.postalCode,
            city: signupForm.signupUser.establishment.billingAddress.city,
            street: signupForm.signupUser.establishment.billingAddress.street,
            additionalDetails:
                signupForm.signupUser.establishment.billingAddress
                    .additionalDetails,
        },
        useDiffrentBillingAddress: signupForm.useDiffrentBillingAddress,
    };

    const onSubmit = (data: any) => {
        updateSignupForm({
            ...signupForm,
            step: nextStep,
            signupUser: {
                ...signupForm.signupUser,
                establishment: {
                    ...signupForm.signupUser.establishment,
                    contactAddress: { ...data.contactAddress },
                    billingAddress: data.useDiffrentBillingAddress
                        ? { ...data.billingAddress }
                        : { ...data.contactAddress },
                },
            },
            useDiffrentBillingAddress: data.useDiffrentBillingAddress,
        });
        if (nextStep && goto) {
            goto(nextStep);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",

                flexDirection: "column",
                alignItems: "flex-start",
                gap: "40px",
            }}
        >
            <Box
                display="flex"
                sx={{
                    flexDirection: "column",
                    gap: "8px",
                }}
            >
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                    }}
                >
                    Adresse de votre établissement
                </Typography>
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "0.875rem",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "1.125rem",
                    }}
                >
                    Renseignez l’adresse de votre établissement
                </Typography>
                <EstablishementAdressFormWrapper
                    onSubmit={onSubmit}
                    defaultValues={defaultValues}
                    formActionComponents={{
                        submit: (
                            <CustomButton
                                type="submit"
                                label="Étape suivante"
                                customsx={{
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    marginTop: "3.5rem",
                                    marginBottom: "auto",
                                }}
                            />
                        ),
                    }}
                />
            </Box>
        </Box>
    );
}
